module.exports = __webpack_public_path__ + "img/location_on.97cdf0ea.svg";